<template>
  <tbody >
    <tr class="" v-for="n in rows" :key="n">
      <td class="pulse" v-for="col in columns">
        <span class="placeholder">.</span>
      </td>
    </tr>
  </tbody>

</template>

<script>
export default {
  name: "DdSkeleton.vue",
  props: {
    columns: {
      required: true,
      type: Number,
    },
    rows: {
      required: true,
      type: Number,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.placeholder {
  color: transparent;
}

</style>
